// 对应字典查询的id 或 code
enum DictEnum {
  // 姓别
  SEX = 4,
  // 公司类型
  COMPANY_TYPE = 124,
  // 文件类型
  FILE_TYPE = 13,
  //证书类型
  CERTIFICATE_TYPE = 32,
  //项目状态
  PROJECT_STATUS = 105,
  //项目承包方式
  PROJECT_GOAL = 129,
  //物品清单
  GOODS_LIST = 75,
  //快递种类
  EXPRESS_TYPE = 82,
  //合同类型
  CONTRACT_TYPE = 61,
  //进销类别
  CONTRACT_CATEGORY = 67,
  //发票类型
  INVOICE_TYPE = 1,
  //开票种类
  INVOICE_KIND = 191,
  //资质类型
  QUALIFICATION_TYPE = 199,
  //消息类型
  MESSAGE_TYPE = 135,
  //消息类型
  TAX_TYPE = 394,
  //请假类型
  LEAVE_TYPE = 419,
  //审核状态
  AUDIT_STATUS = 413,
  //业务类型
  BUSINESS_TYPE = 430,
  //非现金票据类型
  NON_CASH_BILL_TYPE = 436,
  //兑现方式
  CASH_WAY = 441,
  //还款方式
  REPAYMENT_METHOD = 445,
  //还款类型
  REPAYMENT_TYPE = 450,
  //资产来源类型
  ASSET_TYPE = 461,
  //付款方式
  PAYMENT_METHOD = 718,
  //税种
  TAX_TYPE_A = 675,
  //票据类型
  BILL_TYPE = 704,
  //银行名称
  BANK_NAME = 474,
  //税种
  TAX_TYPE_B = 675,
  //支付方式
  PAYMENT_WAY = 471,
  //交易原由
  TRANSACTION_CAUSE = 723,
  //项目标签
  PROJECT_TAGS = 728,
}

export default DictEnum;
